require('/opt/odin/app/frontend/components/summary_suggestions/index.module.scss');module.exports = "../../app/cells/components/summary_suggestions/show.erb";